import { Injectable } from '@angular/core';

declare var gtag: (a: string,b: string,c?: any) => void;

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {
  mostRecentEvents: {[key:string]:string} = {}

  enabled = true;
  constructor() { }

  log(a:string,b:string,payload?:any){
    if(!this.enabled){
      return;
    }

    if(this.mostRecentEvents[b]===payload.event_label){
      console.log('Not repeating analytics message',payload);
      return;
    }
    this.mostRecentEvents[b]=payload.event_label
    gtag(a,b,payload);
  }

  analyticsEvent(action:string,context:string): void {
    this.log('event',action,{
      event_category: action,
      event_label: context
    });
  }

  hasCookie(): boolean {
    const cookies = document.cookie || '';
    return cookies.indexOf('_ga=')>=0;
  }
}
